// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___l91S","title":"styles_title__KYYj2"};